var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShuttle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#DBEBFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5734_48078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 23.5977H44",
    stroke: "#0256B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 29.5977H44",
    stroke: "#0256B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 40.4008H20V22.4008C20 21.446 20.3793 20.5303 21.0544 19.8552C21.7295 19.1801 22.6452 18.8008 23.6 18.8008H40.4C41.3548 18.8008 42.2705 19.1801 42.9456 19.8552C43.6207 20.5303 44 21.446 44 22.4008V40.4008Z",
    stroke: "#0256B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 40.3984V43.9984C44 44.3167 43.8736 44.6219 43.6485 44.847C43.4235 45.072 43.1183 45.1984 42.8 45.1984H39.2C38.8817 45.1984 38.5765 45.072 38.3515 44.847C38.1264 44.6219 38 44.3167 38 43.9984V40.3984",
    stroke: "#0256B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 40.3984V43.9984C26 44.3167 25.8736 44.6219 25.6485 44.847C25.4235 45.072 25.1183 45.1984 24.8 45.1984H21.2C20.8817 45.1984 20.5765 45.072 20.3515 44.847C20.1264 44.6219 20 44.3167 20 43.9984V40.3984",
    stroke: "#0256B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5969 36.7992C27.591 36.7992 28.3969 35.9933 28.3969 34.9992C28.3969 34.0051 27.591 33.1992 26.5969 33.1992C25.6028 33.1992 24.7969 34.0051 24.7969 34.9992C24.7969 35.9933 25.6028 36.7992 26.5969 36.7992Z",
    fill: "#0256B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3937 36.7992C38.3879 36.7992 39.1937 35.9933 39.1937 34.9992C39.1937 34.0051 38.3879 33.1992 37.3937 33.1992C36.3996 33.1992 35.5938 34.0051 35.5938 34.9992C35.5938 35.9933 36.3996 36.7992 37.3937 36.7992Z",
    fill: "#0256B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7969 24.8008V28.4008",
    stroke: "#0256B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1953 24.8008V28.4008",
    stroke: "#0256B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5734_48078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.4,
    height: 38.4,
    fill: "white",
    transform: "translate(12.7969 12.8008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuttle);
export default __webpack_public_path__ + "static/media/shuttle.0d94c896a5409ccf166a1331b9e45378.svg";
export { ForwardRef as ReactComponent };